<template>
  <a-modal
    :visible="visible"
    title="导入奥维地图数据"
    okText="导入"
    @cancel="handleCancelParent"
    @ok="handleOk"
    >
    <p>
      请先使用奥维地图客户端软件导出为 Omap json 格式，导出的文件后缀为 .ovjsn，选择该文件进行导入。
    </p>
    <a-upload
        accept=".ovjsn"
        :fileList="fileList"
        :beforeUpload="beforeUpload"
        :remove="handleRemove">
        <a-button type="primary">选择文件</a-button>
    </a-upload>

    <template slot="footer">
      <a-button key="back" @click="handleCancelParent">取消</a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    markerSetId: String,
  },
  data() {
    return {
      currentStep: 0,
      fileList: [],
      loading: false,
    };
  },
  methods: {
    handleCancelParent() {
      this.$emit('update:visible', false);
    },
    async handleOk() {
      // 导入
      if (this.fileList.length === 0) {
        this.$message.warning('请先选择文件');
        return;
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0]);
      formData.append('markerSetId', this.markerSetId);
      try {
        this.loading = true;
        await this.$api.importAndExport.importFromOmap(formData, {
          // 导入比较耗时，加长超时时间
          timeout: 180000,
        });
        this.loading = false;
        this.$message.success('导入成功');
        this.fileList = [];
        this.$confirm({
          content: '导入成功，是否马上刷新？',
          onOk() {
            window.location.reload();
          },
          onCancel() {},
        });
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },
    beforeUpload(file) {
      this.fileList = [file];
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
  },
  watch: {
    visible() {
    },
  },
};
</script>

<style scoped>

</style>
